module.exports = __webpack_public_path__ + "img/厨房_image.b319c48c.png";